import ChevronImage from "@assets/ndp/ChevronRed.png";
import NdpBG from "@assets/ndp/ndp_bg.png";
import SG61 from "@assets/ndp/sg61.svg";
import ArticleCard from "@blocks/Card/ArticleCard";
import Image from "@elements/ResponsiveImage/Image";
import Heading from "@elements/Typography/Heading";
import { ProcessedArticleData } from "@helper/transformer/useOsResponse";
import { Link } from "react-router";

export const NdpSection = ({
  ndpArticles,
  ndpLink,
  title,
}: {
  ndpArticles?: ProcessedArticleData[];
  ndpLink: string;
  title: string;
}) => {
  return (
    <>
      {ndpArticles && ndpArticles.length > 0 && (
        <div className="border-b border-pink-300 bg-[linear-gradient(180deg,#FFF_0%,#FFE1E8_100%)]">
          <Heading
            Element="h2"
            className="text-red-450 text-2.5md font-bold mt-5 hover:underline hover:cursor-pointer"
          >
            <Link reloadDocument to={ndpLink} target="_blank">
              <Image
                srcWidth={40}
                srcHeight={40}
                src={SG61}
                objectFit="contain"
                alt="தேசிய தினம்"
                className="lg:w-10 w-10 ml-1.5 absolute"
              />
            </Link>
            <Link
              reloadDocument
              to={ndpLink}
              target="_blank"
              className="pl-14 m-auto"
            >
              {title}
              <img
                alt="toggle-button-chevie"
                height={26}
                width={26}
                className="pl-100 inline"
                src={ChevronImage}
              />
            </Link>
          </Heading>
          <div className="flex flex-col lg:flex-row px-5">
            {ndpArticles
              .filter((_, i) => i === 0)
              .map((article) => (
                <ArticleCard
                  key={article.id}
                  displayWidth={390}
                  displayHeight={260}
                  elements={{
                    hasParagraph: false,
                    hasDate: false,
                    hasDateInAgo: true,
                  }}
                  {...article}
                  overrideStyle={{
                    cardWrapper: "w-full lg:w-fit flex flex-col lg:border-b-0",
                    paragraphStyle: "lg:text-2sm",
                    titleStyle:
                      "font-semibold font-primary text-sm2 text-gray-100 hover:text-gray-100",
                    imageWrapperStyle:
                      "w-full max-w-full lg:w-84 h-55 lg:h-64 lg:max-h-64 sm:h-100 sm:w-full",
                    titleWrapper: "gap-0",
                    imageStyle: "h-55 lg:h-64 sm:h-100",
                  }}
                />
              ))}

            <div className="flex-col lg:pl-lg lg:pr-0.5">
              {ndpArticles
                .filter((_, i) => i > 0)
                .map((article, i, row) => (
                  <ArticleCard
                    key={i}
                    displayWidth={135}
                    displayHeight={90}
                    elements={{
                      hasParagraph: false,
                      hasDate: false,
                      hasDateInAgo: true,
                    }}
                    {...article}
                    overrideStyle={{
                      cardWrapper:
                        i + 1 === row.length
                          ? "w-full lg:w-full flex-row-reverse border-b-0"
                          : i === 0
                            ? "w-full lg:w-full flex-row-reverse pb-xs"
                            : "w-full lg:w-full flex-row-reverse py-xs",
                      paragraphStyle: "lg:text-2sm",
                      titleStyle:
                        "font-semibold font-primary text-sm2 text-gray-100 hover:text-gray-100",
                      imageWrapperStyle:
                        "w-31.5 max-w-40 lg:w-31.5 h-23 sm:w-full hidden",
                      titleWrapper: "gap-0",
                      imageStyle: "w-full h-23",
                    }}
                  />
                ))}
            </div>
          </div>
          <div
            className="h-[72px] bg-no-repeat bg-left-bottom bg-cover"
            style={{
              backgroundImage: `url(${NdpBG})`,
            }}
          >
            &nbsp;
          </div>
        </div>
      )}
    </>
  );
};
